/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.linkPicker.button.cancel': 'Annullér',
  'fabric.linkPicker.button.insert': 'Indsæt',
  'fabric.linkPicker.button.save': 'Gem',
  'fabric.linkPicker.clearLink': 'Ryd',
  'fabric.linkPicker.clearLinkText': 'Ryd tekst',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {ingen resultater fundet} one {Der blev fundet {count,number} resultat} other {Der blev fundet {count,number} resultater}}',
  'fabric.linkPicker.linkAriaLabel': 'Skriv eller indsæt et link i feltet',
  'fabric.linkPicker.linkInvalid': 'Indtast en gyldig URL-adresse.',
  'fabric.linkPicker.linkLabel': 'Link',
  'fabric.linkPicker.linkPlaceholder': 'Indsæt et link',
  'fabric.linkPicker.linkTextAriaLabel': 'Visningstekst til link',
  'fabric.linkPicker.linkTextLabel': 'Visningstekst (valgfrit)',
  'fabric.linkPicker.linkTextPlaceholder': 'Tekst, der skal vises',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Set for nylig',
  'fabric.linkPicker.listTitle.results': 'Resultater',
  'fabric.linkPicker.search.error.description': 'Opdater siden, eller kontakt <a>Atlassian-support</a>, hvis det bliver ved med at ske.',
  'fabric.linkPicker.search.error.heading': 'Vi har problemer med at indlæse data.',
  'fabric.linkPicker.search.linkAriaLabel': 'Der vises forslag nedenfor, når du skriver i feltet',
  'fabric.linkPicker.search.linkLabel': 'Søg efter eller indsæt et link',
  'fabric.linkPicker.search.linkPlaceholder': 'Find de seneste links, eller indsæt et nyt link',
  'fabric.linkPicker.search.noResults.description': 'Prøv igen med et andet ord.',
  'fabric.linkPicker.search.noResults.heading': 'Vi kunne ikke finde noget, der opfylder dine søgekriterier.',
  'fabric.linkPicker.status.submitting': 'Indsender',
  'fabric.linkPicker.time.message.updated': 'Opdateret {time}',
  'fabric.linkPicker.time.message.viewed': 'Vist {time}',
  'fabric.linkPicker.unhandledError.description': 'Prøv at genindlæse siden.',
  'fabric.linkPicker.unhandledError.heading': 'Noget gik galt!'
};